// extracted by mini-css-extract-plugin
module.exports = {"trainingTemplate":"styles_trainingTemplate__MRje6","fileUpload":"styles_fileUpload__2tpRv","attachmentContainer":"styles_attachmentContainer__3eN8h"};